import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sys-anl-consultancy',
  templateUrl: './sys-anl-consultancy.component.html',
  styleUrls: ['./sys-anl-consultancy.component.scss']
})
export class SysAnlConsultancyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
